export default __webpack_public_path__ + "static/media/region_hdf_logo.5d27f318.svg";